import * as React from "react";
const SettingsUserIconSvg = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      stroke="#7D8690"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M15 5.2c1.7 1.7 1.7 4.4 0 6-1.7 1.6-4.4 1.7-6 0-1.6-1.7-1.7-4.4 0-6 1.7-1.6 4.3-1.6 6 0M4 20c0-2.5 2-4.5 4.5-4.5h2.6"
    />
    <path
      stroke="#7D8690"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M14 21h2.3l3.4-3.4c.4-.4.4-1 0-1.4l-.9-.9c-.4-.4-1-.4-1.4 0L14 18.7V21h0Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SettingsUserIconSvg;
